function fixBinary (bin) {
  let length = bin.length;
  let buf = new ArrayBuffer(length);
  let arr = new Uint8Array(buf);
  for (let i = 0; i < length; i++) {
    arr[i] = bin.charCodeAt(i);
  }
  return buf;
}

import piexif from 'piexifjs'

export default (image, exifMetadata) => {
  return new Promise(function(resolve) {
    let img_b64 = !!exifMetadata
      ? piexif.insert(exifMetadata, image)
      : image //base64 de la imagen
    let png = img_b64.split(',')[1];
    let binary = fixBinary(window.atob(png));// <-- Usamos la fn "fixBinary"
    let the_file = new Blob([binary], {type: 'image/jpeg'});// <-- Sacamos el encode
    resolve(new File([the_file], 'writed_image.jpg', { type: 'image/jpeg' }))	
  })
}



// WEBPACK FOOTER //
// ./src/utils/writeImage.js